<template lang="pug">
div
  v-toolbar(clipped-left, app)
    v-toolbar-side-icon(@click="drawerOpen = !drawerOpen")
    v-toolbar-title
      router-link(
        :to="{ name: 'dashboard' }",
        style="color: white; text-decoration: none"
      )
        | Site Management System
      span.subheading.ml-3(style="color: grey")
        | {{ version }}
    v-spacer
    v-toolbar-items
    v-combobox(
      v-model="selectedRegion",
      :items="['AU', 'NZ', 'HK']",
      label="Region",
      outlined
    )
    </v-combobox>
      v-btn(:disabled="loggingOut", flat, @click="logout")
        v-progress-circular(v-if="loggingOut", indeterminate)
        span(v-else) Log out
  v-navigation-drawer(v-model="drawerOpen", clipped, app)
    v-list
      template(v-for="(item, index) in items")
        v-list-tile(
          :key="index",
          :to="item.route",
          active-class="grey darken-2"
        )
          v-list-tile-action
            v-icon {{ item.icon }}
          v-list-tile-title {{ item.title }}
      v-divider
      v-list-group(no-action)
        v-list-tile(slot="activator")
          v-list-tile-action
            v-icon edit
          v-list-tile-content
            v-list-tile-title Admin
        v-list-group(sub-group)
          v-list-tile(slot="activator")
            v-list-tile-content
              v-list-tile-title Franchises
          v-list-tile(
            :to="{ name: 'insurances' }",
            active-class="grey darken-2"
          )
            v-list-tile-content Insurances
          v-list-tile(:to="{ name: 'tickets' }", active-class="grey darken-2")
            v-list-tile-content Tickets
        v-list-group(sub-group)
          v-list-tile(slot="activator")
            v-list-tile-content
              v-list-tile-title Jobs
          v-list-tile(
            :to="{ name: 'jobStatuses' }",
            active-class="grey darken-2"
          )
            v-list-tile-content Statuses
        v-list-group(sub-group)
          v-list-tile(slot="activator")
            v-list-tile-content
              v-list-tile-title Issues
          v-list-tile(
            :to="{ name: 'categories' }",
            active-class="grey darken-2"
          )
            v-list-tile-content Categories
          v-list-tile(
            :to="{ name: 'issueStatuses' }",
            active-class="grey darken-2"
          )
            v-list-tile-content Statuses
        v-list-group(sub-group)
          v-list-tile(slot="activator")
            v-list-tile-content
              v-list-tile-title Sites
          v-list-tile(
            :to="{ name: 'siteConfItems' }",
            active-class="grey darken-2"
          )
            v-list-tile-content Configuration items
        v-list-group(sub-group)
          v-list-tile(slot="activator")
            v-list-tile-content
              v-list-tile-title Subcontractors
          v-list-tile(
            :to="{ name: 'priceList' }",
            active-class="grey darken-2"
          )
            v-list-tile-content Default price list
  v-content
    v-container(fluid)
      router-view(:key="$route.fullPath")
</template>

<script>
export default {
  data() {
    return {
      selectedRegion: this.$store.getters.getRegion,
      drawerOpen: true,
      items: [
        {
          title: "Dashboard",
          route: { name: "dashboard" },
          icon: "dashboard",
        },
        {
          title: "Sites",
          route: { name: "sites" },
          icon: "flag",
        },
        {
          title: "Issues",
          route: { name: "issues" },
          icon: "error",
        },
        {
          title: "Jobs",
          route: { name: "jobs" },
          icon: "build",
        },
        {
          title: "Subcontractors",
          route: { name: "subcontractors" },
          icon: "people",
        },
        {
          title: "Franchises",
          route: { name: "franchises" },
          icon: "person",
        },
        {
          title: "Reporting",
          route: { name: "reports" },
          icon: "assessment",
        },
      ],
      loggingOut: false,
    };
  },
  computed: {
    version() {
      return VERSION;
    },
  },
  watch: {
    selectedRegion(newData, oldData) {
      this.$store.dispatch("setRegion", newData);
    },
  },
  methods: {
    logout() {
      this.loggingOut = true;
      this.$store.dispatch("logOut").catch(() => (this.loggingOut = false));
    },
  },
};
</script>

<style>
nav {
  z-index: 4;
}
.boldd {
  background-color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue